import styled from 'styled-components';

const StyledText = styled.p<{ small?: boolean }>`
  margin: 0 8px;
  font-weight: normal;
  font-size: ${(props) => (props.small ? '13px' : '15px')};
  color: ${(props) => props.theme.colors.grey5};
`;

export default StyledText;
